import {getAuth} from "firebase/auth";
import {useAuthState} from "react-firebase-hooks/auth";
import {useObjectVal} from "react-firebase-hooks/database";
import {ref, set} from "firebase/database";
import {database} from "hooks/firebase";
import {useMemo} from "react";

export const useStripeCustomerId = (): [string | undefined, (customerId: string) => Promise<void>, boolean, Error | null] => {
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const userStripeCustomerIdPath = useMemo(() => `user-data/${user?.uid ?? ""}/stripe/customerId`, [user]);
  const [customerId, customerIdLoading, customerIdError] =
      useObjectVal<string>((user && ref(database, userStripeCustomerIdPath)) ?? null);

  const setCustomerId = (customerId: string) => {
    return set(ref(database, userStripeCustomerIdPath), customerId)
  }

  return [customerId, setCustomerId, customerIdLoading, customerIdError ?? null];
}
